export default __webpack_public_path__ + "static/media/beef_mshrms.44e3b61e.jpg";